/**
 * Completion here depends on the source type:
 * - block: at least 1 star obtained
 * - trophy: is just completed at all (it's impossible to submit incorrect solutions)
 * TODO: lab result type not supported yet
 * @param {Object} result
 */
const isSuccessfullyComplete = result => {
	switch (result.resultType) {
		case "trophy":
			return result.isComplete;
		default:
			return result.starsObtained > 0;
	}
};

module.exports = {
	isSuccessfullyComplete,
};
